import { render, staticRenderFns } from "./JVxeDemo2.vue?vue&type=template&id=59815a48&scoped=true"
import script from "./JVxeDemo2.vue?vue&type=script&lang=js"
export * from "./JVxeDemo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59815a48",
  null
  
)

export default component.exports